import { Dayjs } from 'dayjs';

export type DeliveryConfigurationUi = {
  nextDayCutOffTime: Dayjs | null;
  timePeriods: { value: string; label: string }[];
  timePeriodSelected: string;
  deliveryDays: WeekDayDeliveryUi[];
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
};

export type WeekDayDeliveryUi = {
  dayId: string;
  dayName: string;
  enabled: boolean;
  errorMessage?: string;
  minDeliveryTime: Dayjs | null;
  maxDeliveryTime: Dayjs | null;
};

export const initialState: DeliveryConfigurationUi = {
  nextDayCutOffTime: null,
  timePeriods: [
    { value: '24', label: '24h' },
    { value: '36', label: '36h' },
    { value: '48', label: '48h' },
    { value: '60', label: '60h' },
    { value: '72', label: '72h' },
  ],
  timePeriodSelected: '',
  deliveryDays: [],
  cancelDisabled: true,
  saveDisabled: true,
};
